var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "date_svg__a",
    d: "M0 0h60v11.707H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "date_svg__c",
    d: "M0 0h60v45.366H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "date_svg__e",
    d: "M0 60h60V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "date_svg__g",
    d: "M0 60h60V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "date_svg__i",
    d: "M0 60h60V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "date_svg__k",
    d: "M0 60h60V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "date_svg__m",
    d: "M0 60h60V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "date_svg__o",
    d: "M0 60h60V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "date_svg__q",
    d: "M0 60h60V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 6.39)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "date_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#date_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60 11.707H0V5.854C0 2.622 2.517 0 5.624 0h48.75C57.484 0 60 2.622 60 5.854v5.853z",
    fill: "#CCC",
    fillRule: "nonzero",
    mask: "url(#date_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 16.634)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "date_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#date_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60 39.695c0 3.132-2.517 5.67-5.625 5.67H5.624C2.517 45.366 0 42.828 0 39.696V0h60v39.695z",
    fill: "#F3F3F3",
    fillRule: "nonzero",
    mask: "url(#date_svg__d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "date_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#date_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#33CCCD",
    fillRule: "nonzero",
    mask: "url(#date_svg__f)",
    d: "M19.024 30.732h8.78v-8.78h-8.78z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "date_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#date_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.317 30.732h8.78v-8.78h-8.78v8.78zm23.415 0h8.78v-8.78h-8.78v8.78zm11.707 0h8.78v-8.78h-8.78v8.78zM19.024 40.976h8.78v-8.78h-8.78v8.78z",
    fill: "#D9D9D9",
    fillRule: "nonzero",
    mask: "url(#date_svg__h)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "date_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#date_svg__i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#545774",
    fillRule: "nonzero",
    mask: "url(#date_svg__j)",
    d: "M7.317 40.976h8.78v-8.78h-8.78z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "date_svg__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#date_svg__k"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.732 40.976h8.78v-8.78h-8.78v8.78zm11.707 0h8.78v-8.78h-8.78v8.78zM19.024 51.22h8.78v-8.781h-8.78v8.78zm-11.707 0h8.78v-8.781h-8.78v8.78z",
    fill: "#D9D9D9",
    fillRule: "nonzero",
    mask: "url(#date_svg__l)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "date_svg__n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#date_svg__m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#33CCCD",
    fillRule: "nonzero",
    mask: "url(#date_svg__n)",
    d: "M30.732 51.22h8.78v-8.781h-8.78z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "date_svg__p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#date_svg__o"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "nonzero",
    mask: "url(#date_svg__p)",
    d: "M42.439 51.22h8.78v-8.781h-8.78z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "date_svg__r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#date_svg__q"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.17 8.78a2.935 2.935 0 01-2.926 2.927A2.935 2.935 0 017.317 8.78V2.927A2.935 2.935 0 0110.244 0a2.935 2.935 0 012.927 2.927V8.78zm39.513 0a2.935 2.935 0 01-2.927 2.927A2.935 2.935 0 0146.83 8.78V2.927A2.935 2.935 0 0149.756 0a2.935 2.935 0 012.927 2.927V8.78zm-19.756 0A2.935 2.935 0 0130 11.707a2.935 2.935 0 01-2.927-2.927V2.927A2.935 2.935 0 0130 0a2.935 2.935 0 012.927 2.927V8.78z",
    fill: "#545874",
    fillRule: "nonzero",
    mask: "url(#date_svg__r)"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgDate as ReactComponent };